import {createSelector} from 'reselect';
import getAddresses from './DeliveryAddressSelectors/getAddresses';

export default createSelector(
  [getAddresses],
  addresses => (addresses && Object.values(addresses) ? Object.values(addresses).length : 0),
);
